import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesResolutionsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-resolutions',
	path: '/secure/admin/ViewResolutions.jspa',
};
